import React from 'react';
import { Card } from '../../../components/Card/Card';
import { NoData } from '../../../components/NoData/NoData';
import { graphql } from '../../../generated';
import { t } from '../../../locales/translate';
import { withSuspendedCard } from '../../../util/suspense';
import { AreaChart, Dataset } from '../../../components/Charts/AreaChart';
import { Text } from '../../../components/text/text';
import { formatCurrency } from '../../../util/formatters';
import { useSuspenseQuery } from '@apollo/client';
import { SalesOverTimePeriod } from '../../../generated/graphql';

const TURN_OVER = graphql(`
  query TurnoverOverTime($from: ISO8601DateTime, $to: ISO8601DateTime, $period: SalesOverTimePeriod) {
    statistics {
      turnoverOverTime(during: { from: $from, to: $to }, period: $period) {
        total
        result {
          date
          total
        }
      }
    }
  }
`);

interface Props {
  from: Date;
  to: Date;
  period: SalesOverTimePeriod;
}

function TurnoverOverTime$({ from, to, period }: Props): JSX.Element | null {
  const { data } = useSuspenseQuery(TURN_OVER, {
    variables: {
      from: from,
      to: to,
      period: period,
    },
  });

  const total = data?.statistics?.turnoverOverTime?.total;
  const turnoverOverTimeData = data?.statistics?.turnoverOverTime;
  const dataset: Dataset[] = [
    {
      title: t.component.turnover.period[period],
      values: turnoverOverTimeData?.result.map((e) => e.total) || [],
      color: '#00EDFF80',
    },
  ];

  return (
    <Card
      size="dashboard"
      title={t.component.turnover.title}
      actions={
        turnoverOverTimeData &&
        turnoverOverTimeData.result.length > 0 && (
          <Text type="card-label">
            {t.component.turnover.total} {formatCurrency(total)}
          </Text>
        )
      }
    >
      {turnoverOverTimeData && turnoverOverTimeData.result.length > 0 ? (
        <AreaChart
          style={{ height: 249 }}
          datasets={dataset}
          labels={turnoverOverTimeData.result.map((e) => e.date)}
          formatTooltipValues="currency"
          showTimeOnXAxis={period === 'hour'}
        />
      ) : (
        <NoData description={t.component.turnover.noData} />
      )}
    </Card>
  );
}

export const TurnoverOverTime = withSuspendedCard(TurnoverOverTime$, {
  loadingTitle: t.component.turnover.title,
  loadingHeight: 348,
});
